import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import user from './modules/user'
// import Cookies from 'js-cookie'
import registration from './modules/registration'
import course from './modules/course'
import learn from './modules/learn'
import quiz from './modules/quiz'
import exam from './modules/exam'
import braintree from './modules/braintree'
import createPersistedState from 'vuex-persistedstate'
import getLocalDb from './db'
import axios from 'axios'

Vue.use(Vuex)
const RSS_FEED_URLS = [
  'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.foodsafetynews.com/food-recalls/feed',
  'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.fda.gov/about-fda/contact-fda/stay-informed/rss-feeds/food-allergies/rss.xml',
  'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.canada.ca/en/food-inspection-agency.atom.xml'
]
async function readRssFeeds (url) {
  return new Promise(function (resolve, reject) {
    axios({
      url: url,
      method: 'GET'
    }).then(response => {
      if (typeof response.data !== 'undefined') {
        resolve(response.data.items)
      }
    }).catch(error => {
      reject(new Error(error))
    })
  })
}

async function getNewsFeeds () {
  let newsArr = []
  for (const url of RSS_FEED_URLS) {
    const contents = await readRssFeeds(url)
    newsArr.push(...contents)
  }
  let data = newsArr.sort(function (a, b) {
    return new Date(b.pubDate) - new Date(a.pubDate)
  })
  return new Promise(function (resolve, reject) {
    if (data) {
      resolve(data)
    } else {
      reject(new Error('error getting news feed'))
    }
  })
}

const store = new Vuex.Store({
  strict: true,
  getters,
  modules: {
    user,
    registration,
    course,
    learn,
    quiz,
    exam,
    braintree
  },
  state: {
    dbObject: [],
    levelsCount: 7, // don't make it 0
    loadingCourseDialog: false,
    loadingCourseDialogMsg: '',
    snackBarDisplay: false,
    snackBarColor: 'success',
    snackBarText: 'Hello',
    rightDrawer: false,
    leftDrawer: false,
    guestLeftDrawer: false,
    loadingDialog: false,
    appHeight: 600,
    appWidth: 400,
    token: '',
    dashboardTourStart: 0,
    tourCurrentStep: -1,
    pageTitle: '',
    device: {
      isMobile: false,
      isTablet: false,
      isDesktop: false
    },
    settingsDrawer: false,
    newUserLoggedin: true,
    refreshHomePage: false,
    tourStatus: true,
    learnStatus: true,
    quizStatus: true,
    rssFeedNews: [],
    newsDialog: false,
    allNewsDialog: false,
    userSeenNewsOnDate: '',
    isCompactHeader: true,
    mobileStatusBarStatus: true
  },
  actions: {
    connectDb ({dispatch, state, getters, commit, rootGetters}, deckId) {
      return getLocalDb(store, deckId)
    },
    async fetchRssFeedNews ({state, commit}) {
      const news = await getNewsFeeds()
      commit('setRssFeed', news)
    }
  },
  mutations: {
    setIsCompactHeader (state, data) {
      state.isCompactHeader = data
    },
    setUserSeenNewsOnDate (state, data) {
      state.userSeenNewsOnDate = data
    },
    setNewsDialog (state, data) {
      state.newsDialog = data
    },
    setAllNewsDialog (state, data) {
      state.allNewsDialog = data
    },
    setRssFeed (state, data) {
      state.rssFeedNews = data
    },
    setDbObject (state, data) {
      state.dbObject = data
    },
    setLevelsCount (state, data) {
      state.levelsCount = data
    },
    setAuthToken (state, value) {
      state.token = value
    },
    setAppHeight (state, value) {
      state.appHeight = value
    },
    setAppWidth (state, value) {
      state.appWidth = value
    },
    setLoadingDialog (state, value) {
      state.loadingDialog = value
    },
    hideSnackBar (state, msg) {
      state.snackBarDisplay = false
    },
    flashSuccess (state, msg) {
      state.snackBarText = msg
      state.snackBarColor = 'success'
      state.snackBarDisplay = true
    },
    flashInfo (state, msg) {
      state.snackBarText = msg
      state.snackBarColor = '#b79e30'
      state.snackBarDisplay = true
    },
    flashError (state, msg) {
      state.snackBarText = msg
      state.snackBarColor = 'error'
      state.snackBarDisplay = true
    },
    toggleRightDrawer (state, flag) {
      state.rightDrawer = flag
    },
    toggleLeftDrawer (state, flag) {
      state.leftDrawer = flag
    },
    toggleGuestLeftDrawer (state, flag) {
      state.guestLeftDrawer = flag
    },
    setTourCurrentStep (state, flag) {
      state.tourCurrentStep = flag
    },
    setDashboardTourStart (state, flag) {
      state.dashboardTourStart = flag
    },
    setPageTitle (state, text) {
      state.pageTitle = text
    },
    setLoadingCourseDialog (state, data) {
      state.loadingCourseDialog = data.status
      state.loadingCourseDialogMsg = data.msg
    },
    setSettingsDrawer (state, flag) {
      state.settingsDrawer = flag
    },
    setNewUserLoggedin (state, flag) {
      state.newUserLoggedin = flag
    },
    setRefreshHomePage (state, flag) {
      state.refreshHomePage = flag
    },
    setTourStatus (state, flag) {
      state.tourStatus = flag
    },
    setLearnStatus (state, flag) {
      state.learnStatus = flag
    },
    setQuizStatus (state, flag) {
      state.quizStatus = flag
    },
    setMobileStatusBarStatus (state, flag) {
      state.mobileStatusBarStatus = flag
    }
  },
  plugins: [createPersistedState({
    key: 'rch',
    paths: [
      'tourStatus',
      'learnStatus',
      'quizStatus',
      'course',
      'user',
      'token',
      'dbObject',
      'levelsCount',
      'userSeenNewsOnDate',
      'learn.folders',
      'learn.allViews',
      'learn.lastLearnRoute',
      'quiz.tokenUsedInQuestions',
      'exam',
      'registration.user'
    ],
    storage: window.sessionStorage
  })
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js